import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const sizeClass = {
    sm: 'size-3 border',
    md: 'size-4 border-2',
    lg: 'size-6 border-2'
};
/** Indeterminate progress indicator for local asynchronous work. */ export const SpecraSpinner = /*#__PURE__*/ React.forwardRef(({ className, label = 'Loading', size = 'md', ...props }, ref)=>{
    const classes = cn('specra-spinner inline-block animate-spin rounded-full border-muted-foreground/25 border-t-foreground', sizeClass[size], className);
    return label === false ? /*#__PURE__*/ _jsx("span", {
        "aria-hidden": "true",
        className: classes,
        ref: ref,
        ...props
    }) : // biome-ignore lint/a11y/useSemanticElements: a span preserves the inline indicator API while exposing status semantics.
    /*#__PURE__*/ _jsx("span", {
        className: classes,
        ref: ref,
        role: "status",
        ...props,
        children: /*#__PURE__*/ _jsx("span", {
            className: "sr-only",
            children: label
        })
    });
});
SpecraSpinner.displayName = 'SpecraSpinner';
